export enum UserStatusEnum {
  Deactive = 0,
  Active = 1,
}
